(() => {
  function applyHeadingVisibility(rvSection, hasItems) {
    if (!(rvSection instanceof HTMLElement)) return;

    const headingSection = rvSection.previousElementSibling;
    if (!(headingSection instanceof HTMLElement)) return;
    if (!headingSection.classList.contains("shopify-section")) return;

    headingSection.style.display = hasItems ? "" : "none";
  }

  function syncAllRecentlyViewedSections() {
    document.querySelectorAll(".rv-section").forEach((rvInnerSection) => {
      const rvSection = rvInnerSection.closest('[id^="shopify-section-"]');
      if (!(rvSection instanceof HTMLElement)) return;

      const hasItems = rvInnerSection.getAttribute("data-rv-has-items") === "true";
      applyHeadingVisibility(rvSection, hasItems);
    });
  }

  document.addEventListener("recently_viewed_products:visibility_change", (event) => {
    const sectionId = event.detail?.sectionId;
    if (!sectionId) return;

    const rvSection = document.getElementById(`shopify-section-${sectionId}`);
    if (!(rvSection instanceof HTMLElement)) return;

    applyHeadingVisibility(rvSection, !!event.detail?.hasItems);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAllRecentlyViewedSections);
  } else {
    syncAllRecentlyViewedSections();
  }

  window.addEventListener("load", syncAllRecentlyViewedSections);
  document.addEventListener("shopify:section:load", syncAllRecentlyViewedSections);
})();
